import React from 'react'

import { useLocation } from 'react-router-dom'

import './ActionBar.scss'
import logo from '../../../assets/images/thales-logo.svg'

import { Link } from 'react-router-dom'
import { apiUrl, setApiUrl } from '../../../config/config'

function ActionBar() {
    const location = useLocation()

    function renderActionButtons() {
        return (
            <div className="header-menu-right">
                <button
                    className="text-bluegrey-500 hidden medium:block pl-l Title"
                    data-test-id="header-text"
                    onClick={renderAskSimulatorHostname}
                >
                    Configuration
                </button>
            </div>
        )

        if (location.pathname.toString() !== '/tactical') {
            return (
                <div className="header-menu-right">
                    <Link to="/import">
                        <button className="btn outline primary mr-l" data-test-id="header-button-import">
                            Import
                        </button>
                    </Link>
                    <Link to="/create">
                        <button className="btn filled primary" data-test-id="header-button-new">
                            New
                        </button>
                    </Link>
                </div>
            )
        }
    }

    function renderAskSimulatorHostname() {
        let userInput = prompt('Please enter the Hat-Simulator host name:', apiUrl)

        if (userInput !== null) {
            setApiUrl(userInput)
        }
    }

    return (
        <div className="header">
            <div className="header-brand">
                <img src={logo as unknown as string} className="App-logo" alt="logo" data-test-id="header-logo" />
                <Link to="/">
                    <span className="text-bluegrey-500 hidden medium:block pl-l Title" data-test-id="header-text">
                        NSERC Alliance
                    </span>
                </Link>
            </div>
            <div className="header-divider hidden medium:block"></div>
            <div className="header-menu">{renderActionButtons()}</div>
        </div>
    )
}

export default ActionBar
